import { avoidBreakInside } from '@provider/print';
import { Link } from '@ui/kit';
import { generateJsxKey } from '@utils/ast';
import { jsx } from 'react/jsx-runtime';

function printLink(data, context) {
  return /*#__PURE__*/jsx(Link, {
    ...data.props,
    theme: "inline",
    ...avoidBreakInside(),
    children: data.children
  }, generateJsxKey(context));
}

export { printLink };
//# sourceMappingURL=printer.link.js.map
